import React from "react";
import { Spinner } from "react-bootstrap";
import { BiChevronLeft } from "react-icons/bi";
import { BsArrowRight, BsCoin } from "react-icons/bs";
import ImageUploader from "../../Components/ImageUploader";
import Keywords from "../../Components/Keywords";
import Loading from "../../Components/Loading";
import LocationPicker from "../../Components/LocationPicker";
import Region from "../../Components/Region";
import { useCreateAds } from "./Hooks";
import { MdAddToPhotos, MdVerifiedUser } from "react-icons/md";
import { renderPrice } from "../../Utils/functions";
import { toast } from "react-toastify";
import { RiVipCrownFill } from "react-icons/ri";
const CreateAds = () => {
  return <Layout></Layout>;
};
const Step1 = ({ handler, value }) => {

  return (
    <div className="row">
      <div className="col-12 mt-2">
        <label className="form-label labelinput" htmlFor="first-name">
          عنوان
        </label>

        <input
          className="form-control"
          id="first-name"
          type="text"
          placeholder="عنوان آگهی خود را وارد نمایید"
          onChange={({ target: { value } }) => {
            handler("title", value);
          }}
          value={value("title")}
        />
        <small className="fs-10">
          در عنوان بهتر است از ویژگی های متمایز نام برده شود
        </small>
      </div>
      <div className="col-12 mt-4">
        <label className="form-label labelinput" htmlFor="first-name">
          توضیحات
        </label>

        <textarea
          className="form-control"
          id="first-name"
          type="text"
          rows={8}
          placeholder="توضیحات محصول را اینجا وارد نمایید"
          onChange={({ target: { value } }) => {
            handler("description", value);
          }}
          value={value("description")}
        />
        <small className="fs-10">توضیحات راجع به محصول موردنظر</small>
      </div>
      <div className="col-12 mt-4">
        <label className="form-label labelinput" htmlFor="first-name">
          نوع آگهی
        </label>
        <select
          className="form-control"
          id="email2"
          type="text"
          // defaultValue={user?.user?.sex}
          onChange={({ target: { value } }) => {
            handler("model", value);
          }}
          value={value("model")}
        >
          <option>انتخاب کنید</option>
          <option value={"sale"}>فروش</option>
          <option value={"request"}>درخواست</option>
          <option value={"rent"}>اجاره</option>
          <option value={"introduction"}>معرفی</option>
          <option value={"buy"}>خرید</option>
          <option value={"other"}>سایر</option>
        </select>
        <small className="fs-10">نوع آگهی خود را انتخاب نمایید</small>
      </div>
    </div>
  );
};
const Step2 = ({ handler, value }) => {
  return (
    <div className="row">
      <div className="col-12 mt-2">
        <Region set={handler} value={value} />
      </div>
      <div className="col-12 mt-4">
        <label className="form-label labelinput" htmlFor="first-name">
          آدرس
        </label>

        <input
          className="form-control"
          id="first-name"
          type="text"
          placeholder="آدرس آگهی را وارد نمایید"
          onChange={({ target: { value } }) => {
            handler("addres", value);
          }}
          value={value("addres")}
        />
        <small className="fs-10">آدرس مورد نظر را دقیق وارد کنید</small>
      </div>
    </div>
  );
};

export default CreateAds;
const Layout = () => {
  const {
    init,
    loading,
    handler,
    form,
    store,
    value,
    edit,
    setForm,
    user,
    publised,
    searchParams,
    loadingCheck,
    check,
    renderTotoalPrice,
  } = useCreateAds();
  const render = () => {
    switch (form.step) {
      case 1:
        return (
          <div className="">
            <div className="row justify-content-center">
              <div className="col-12 ">
                <Step1 value={value} handler={handler} />
                <div className="row justify-content-end ">
                  <div className="col-4 d-flex justify-content-end">
                    <button
                      className="btn btn-primary w-50 "
                      onClick={searchParams.get("ads_id") ? edit : store}
                    >
                      {loading.step1 ? (
                        <>
                          <Spinner size="sm" />{" "}
                        </>
                      ) : (
                        "ادامه"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="">
            <div className="row justify-content-center">
              <div className="col-12">
                <Step2 value={value} handler={handler} />
                <div className="row justify-content-end">
                  <div className="col-4 d-flex justify-content-end">
                    <button className="btn btn-primary w-50" onClick={edit}>
                      {loading.edit ? (
                        <>
                          <Spinner size="sm" />{" "}
                        </>
                      ) : (
                        "ادامه"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="mt-2">
                  <ImageUploader
                    element={{
                      key: "main_image",
                      label: "عکس اصلی",
                      subLabel: "عکس شاخص محصول خود را بارگذای نمایید",
                    }}
                    form={form}
                    setForm={setForm}
                    single={true}
                  />
                </div>

                <div className="mt-4">
                  <ImageUploader
                    element={{
                      key: "product_images",
                      label: "عکس های محصول",
                      subLabel: "می توانید چندین عکس را بارگذاری نمایید",
                    }}
                    form={form}
                    setForm={setForm}
                    single={false}
                  />
                </div>
                <Keywords
                  form={form}
                  setForm={setForm}
                  options={{
                    title: "کلمات کلیدی",
                    key: "keywords",
                  }}
                />
                <div className="row justify-content-end">
                  <div className="col-4 d-flex justify-content-end">
                    <button className="btn btn-primary w-50" onClick={edit}>
                      {loading.edit ? (
                        <>
                          <Spinner size="sm" />{" "}
                        </>
                      ) : (
                        "ادامه"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 4:
        return (
          <div className="">
            <div className="row justify-content-center">
              <div className="col-12 ">
                <div className="mb-2 mt-2">
                  <label className="labelinput">نوع شخص آگهی دهنده</label>
                  <p className="fs-10 mb-1">مشخص کردن نوع شخص آگهی دهنده</p>
                  <div className="d-flex align-items-center">
                    <div className="check-box-wrapper">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDisabled"
                        id="flexRadioDisabled"
                        onClick={() => {
                          setForm({ ...form, type: "personal" });
                        }}
                        checked={form.type === "personal"}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDisabled"
                      >
                        شخصی
                      </label>
                    </div>
                    <div className="check-box-wrapper">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDisabled"
                        id="flexRadioCheckedDisabled"
                        onClick={() => {
                          setForm({ ...form, type: "company" });
                        }}
                        checked={form.type ? form.type == "company" : true}
                      />
                      {!form.type && setForm({ ...form, type: "company" })}
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioCheckedDisabled"
                      >
                        شرکتی
                      </label>
                    </div>
                  </div>
                </div>
                <div>
                  {form.type === "personal" ? (
                    <>
                      <div className="col-12 mt-3">
                        <label className="form-label labelinput" htmlFor="first-name">
                          نام و نام خانوادگی
                        </label>

                        <input
                          className="form-control"
                          id="first-name"
                          type="text"
                          placeholder="نام و نام خانوادگی خود را وارد کنید"
                          onChange={({ target: { value } }) => {
                            handler("fullname", value);
                          }}
                          value={form?.fullname}
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="form-label labelinput" htmlFor="first-name">
                          موبایل
                        </label>

                        <input
                          className="form-control"
                          id="first-name"
                          type="number"
                          placeholder="موبایل خود را وارد کنید"
                          onChange={({ target: { value } }) => {
                            handler("mobile", value);
                          }}
                          value={user?.mobile}
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="form-label labelinput" htmlFor="first-name">
                          ایمیل
                        </label>

                        <input
                          className="form-control"
                          id="first-name"
                          type="email"
                          placeholder="ایمیل خود را وارد کنید"
                          onChange={({ target: { value } }) => {
                            handler("email", value);
                          }}
                          value={user?.email}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-12 mt-3">
                        <label className="form-label labelinput" htmlFor="co_name">
                          نام شرکت
                        </label>

                        <input
                          className="form-control"
                          id="co_name"
                          type="text"
                          placeholder="نام شرکت خود را وارد کنید"
                          onChange={({ target: { value } }) => {
                            handler("co_name", value);
                          }}
                          value={value("co_name")}
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="form-label labelinput" htmlFor="co_tell">
                          تلفن شرکت
                        </label>

                        <input
                          className="form-control"
                          id="co_tell"
                          type="number"
                          placeholder="تلفن شرکت خود را وارد کنید"
                          onChange={({ target: { value } }) => {
                            handler("co_tell", value);
                          }}
                          value={value("co_tell")}
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="form-label labelinput" htmlFor="co_mobile">
                          موبایل شرکت
                        </label>

                        <input
                          className="form-control"
                          id="co_mobile"
                          type="number"
                          placeholder="موبایل شرکت خود را وارد کنید"
                          onChange={({ target: { value } }) => {
                            handler("co_mobile", value);
                          }}
                          value={value("co_mobile")}
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="form-label labelinput" htmlFor="co_addres">
                          آدرس شرکت
                        </label>

                        <input
                          className="form-control"
                          id="co_addres"
                          type="text"
                          placeholder="آدرس شرکت خود را وارد کنید"
                          onChange={({ target: { value } }) => {
                            handler("co_addres", value);
                          }}
                          value={value("co_addres")}
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="form-label labelinput" htmlFor="co_url">
                          آدرس وب سایت
                        </label>

                        <input
                          className="form-control"
                          id="co_url"
                          type="url"
                          placeholder="آدرس وب سایت شرکت خود را وارد کنید"
                          onChange={({ target: { value } }) => {
                            handler("co_url", value);
                          }}
                          value={value("co_url")}
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className="col-12 mt-3">
                  <label className="form-label labelinput" htmlFor="first-name">
                    قیمت آگهی (تومان)
                  </label>
                  <div className="check-box-wrapper mb-3 mt-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dwkadmakwmdk"
                      id="tavaCheck"
                      onClick={() => {
                        setForm({ ...form, tava: !form.tava });
                      }}
                      checked={form.tava}
                    />
                    <label className="form-check-label" htmlFor="tavaCheck">
                      قیمت به صورت توافقی
                    </label>
                  </div>
                  <input
                    className="form-control"
                    id="first-name"
                    type="number"
                    placeholder=" قیمت را وارد کنید"
                    onChange={({ target: { value } }) => {
                      handler("price", value);
                    }}
                    disabled={form.tava}
                    value={value("price")}
                  />
                </div>
                <div className="row justify-content-end mt-2">
                  <div className="col-4 d-flex justify-content-end">
                    <button className="btn btn-primary w-50" onClick={edit}>
                      {loading.edit ? (
                        <>
                          <Spinner size="sm" />{" "}
                        </>
                      ) : (
                        "ادامه"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 5:
        return (
          <div className="">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="col-12">
                  <label className="labelinput">انتخاب تنظیمات آگهی</label>
                  <div>
                    <span className="fs-10">نوع قیمت گذاری را انتخاب کنید</span>
                  </div>
                  {init?.options?.map(op => {
                    return (
                      <div className="option mt-2" key={op.id}>
                        <div>
                          <MdVerifiedUser color="#0099FF" size={"1.5rem"} />
                        </div>
                        <div className="option-content">
                          <p className="title">{op.title}</p>
                          <p className="description">{op.description}</p>
                        </div>
                        <div className="check-box">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`flexRadioDisabled${op.id}`}
                            id={`flexRadioDisabled${op.id}`}
                            onClick={() => {
                              if (form.option?.length > 0) {
                                if (form.option.includes(op.id)) {
                                  setForm({
                                    ...form,
                                    option: form.option.filter(
                                      de => de != op.id
                                    ),
                                    status: false,
                                  });
                                } else {
                                  setForm({
                                    ...form,
                                    option: [...form.option, op.id],
                                    status: false,
                                  });
                                }
                              } else {
                                setForm({
                                  ...form,
                                  option: [op.id],
                                  status: false,
                                });
                              }
                            }}
                            checked={form.option.includes(op.id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`flexRadioDisabled${op.id}`}
                          >
                            {renderPrice(op.price)}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <hr />
            <div className="row mb-2">
              <div className="col">
                <h5 className="fs-15 fs-500">ثبت کد تخفیف</h5>
              </div>
            </div>

            <div className="row g-3 justify-content-between">
              <div className="col">
                <label htmlFor="inputPassword2" className="visually-hidden">
                  کد تخفیف
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputPassword2"
                  placeholder="کد تخفیف"
                  onChange={({ target: { value } }) => {
                    setForm({ ...form, off_code: value });
                  }}
                />
              </div>
              <div className="col-auto">
                <button
                  type="submit"
                  onClick={check}
                  className="btn btn-primary mb-3"
                >
                  {loadingCheck ? <Spinner size="sm" /> : "ثبت کد تخفیف"}
                </button>
              </div>
            </div>
            <hr />
            <div className="d-flex justify-content-between">
              <p className="fs-14 fw-light">هزینه آگهی : </p>
              {form.status ? (
                <>
                  {form?.option || +form.total_price > 0 ? (
                    <>
                      <p className="fs-14 fw-bold text-danger">
                        <span className="text-primary">
                          {renderPrice(form.new_total_price) || "-"}
                        </span>
                        <span
                          className="text-danger fs-14 fw-300 mx-3 "
                          style={{ textDecoration: "line-through" }}
                        >
                          {renderPrice(
                            renderTotoalPrice(init?.options) +
                            (form.total_price ? +form.total_price : 0)
                          )}{" "}
                        </span>
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="fs-14 fw-bold text-danger">رایگان</p>
                    </>
                  )}
                </>
              ) : (
                <>
                  <p className="fs-14 fw-bold text-danger">
                    {form.total_price == "0" && form.option.length == 0
                      ? "رایگان"
                      : renderPrice(
                        renderTotoalPrice(init?.options) + +form.total_price
                      )}
                  </p>
                </>
              )}
            </div>
            <div className="row justify-content-end mt-2">
              <div className="col d-flex justify-content-end">
                <button className="btn btn-primary w-50" onClick={publised}>
                  {loading.edit ? (
                    <>
                      <Spinner size="sm" />{" "}
                    </>
                  ) : form.category_price == "0" && form.option.length == 0 ? (
                    "ثبت آگهی"
                  ) : (
                    "ثبت و پرداخت آگهی"
                  )}
                </button>
              </div>
            </div>
          </div>
        );
      case "selectCategory":
        return (
          <div className="row justify-content-center create-ads">
            <div className="col-lg-12 px-4 py-3">
              {loading.get ? (
                <Loading count={4} height={"130px"} />
              ) : (
                <>
                  {form.selected.id && (
                    <button
                      className="d-flex align-items-center btn btn-outline-danger mt-2 mb-3"
                      onClick={() => {
                        handler("selected", {});
                      }}
                    >
                      <BsArrowRight style={{ marginLeft: "6px" }} />
                      <span className="kt-selector-row__title fs-12">
                        بازگشت به همهٔ دسته‌ها
                      </span>
                    </button>
                  )}
                  {(form.selected.id
                    ? form.selected.childs
                    : init?.categories
                  ).map((category, count, row) => {
                    return (
                      <div
                        key={count}
                        className="category-selector__item"
                        onClick={() => {
                          if (!category.childs) {
                            setForm({ ...form, selected: category, step: 1 });
                          } else {
                            handler("selected", category);
                          }
                        }}>

                        <div className="kt-selector-row">
                          <div className="kt-base-row kt-base-row--large kt-base-row--has-icon">
                            <div className="kt-base-row__start">
                              <i className="kt-icon kt-icon-real-estate kt-icon--lg kt-base-row__icon" />
                              <p className="kt-selector-row__title ">
                                {category.title}
                                {category.need_expense == 1 &&
                                  <span className="me-2" style={{ color: "rgb(245, 128, 62)" }} >
                                    (
                                    <BsCoin className="ms-1" />
                                    غیر رایگان
                                    )
                                  </span>
                                }
                                {category.need_plan == 1 &&
                                  <span className="me-2" color="rgb(245, 128, 62)" style={{ color: "rgb(245, 128, 62)" }} >
                                    (
                                    <RiVipCrownFill className="ms-1" />
                                    نیاز به اشتراک
                                    )
                                  </span>
                                }
                              </p>
                            </div>
                            <div className="kt-base-row__end">
                              <BiChevronLeft size={"23px"} />
                            </div>
                          </div>
                          {count + 1 === row.length ? (
                            <></>
                          ) : (
                            <hr className="kt-divider" />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        );

      default:
        break;
    }
  };
  return (
    <div className="">
      <div className="row justify-content-center">
        <div className="col-8 col-lg-9">
          <div className="card p-2 rounded px-4">{render()}</div>
        </div>
        <div className="col-4 col-lg-3">
          <div className="layout-steper card p-2 ">
            <h5>مراحل ثبت آگهی</h5>
            <p>لطفا تمامی مراحل را انجام دهید</p>
            {/* form.selected.id && !form.selected.childs */}

            <ol className="stepper">
              {[
                {
                  label: "انتخاب دسته بندی",
                  active: form.step == "selectCategory",
                  complete: form.step !== "selectCategory",
                  step: "selectCategory",
                },
                {
                  label: "مشخصات کلی",
                  active: form.step == 1,
                  step: 1,
                  complete: form.step > 1,
                },
                {
                  label: "موقعیت مکانی",
                  active: form.step == 2,
                  step: 2,
                  complete: form.step > 2,
                },
                {
                  label: "اطلاعات تکمیلی",
                  active: form.step == 3,
                  complete: form.step > 3,
                  step: 3,
                },
                {
                  label: "اطلاعات الزامی",
                  active: form.step == 4,
                  complete: form.step > 4,
                  step: 4,
                },
                {
                  label: "فاکتور نهایی",
                  active: form.step == 5,
                  complete: form.step > 5,
                  step: 5,
                },
              ].map((item, count) => (
                <li
                  className={`stepper-item ${item.active && "active"} ${item.complete && "complete"
                    }`}
                  onClick={() => {
                    if (item.step == "selectCategory") {
                      if (
                        form.status == "draft" ||
                        !searchParams.get("ads_id")
                      ) {
                        setForm({ ...form, step: item.step, selected: {} });
                      } else {
                        toast.error("دسته بندی قابل ویرایش نیست");
                      }
                    } else {
                      setForm({ ...form, step: item.step });
                    }
                  }}
                >

                  <div className="d-flex align-items-center flex-column justify-content-between">
                    <span className="stepper-counter">{count + 1}</span>
                    {count !== 5 && <span className="stepper-line" />}
                  </div>
                  <a href="#" className="stepper-link">
                    <span>{item.label}</span>
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};
